import React from 'react'
import { Link } from "gatsby"
import { Button } from "nzk-react-components"
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px 0;
`

export const ParentsV2_CTA = (props: {
  cta: {
    url: string
    label: string
  }
}) => {

  return <Wrapper className='cta'>
    <Link to={props.cta.url}>
      <Button theme='primary'>{props.cta.label}</Button>
    </Link>
  </Wrapper>
}
